import React, { useState } from 'react';

const topics = [
    {
        id: 1,
        title: "JSON Intro",
        content: `JSON (JavaScript Object Notation) is a lightweight data-interchange format that is easy for humans to read and write, and easy for machines to parse and generate. JSON is derived from JavaScript, appearing in syntax and format that those familiar with the language would understand, but the format is text-only. JSON is both language and platform-independent and can be used in various programming environments.

        JSON is primarily used to transmit data between a server and web application as an alternative to XML. JSON objects are handled through names/values pairs played out in an ordered list. Unlike XML, JSON requires fewer bytes for data transmission, and serialization is faster and easier with JSON. 

        The structure of JSON is simple, has a flexible schema, and can be parsed effortlessly by JavaScript's JSON.parse() method, making it highly suitable for APIs and web services. These features contribute significantly to JSON’s popularity in web development.`,
        example: `{
    "name": "John",
    "age": 30,
    "car": null
}`
    },
    {
        id: 2,
        title: "JSON Syntax",
        content: `The syntax of JSON is straightforward and readable, making it an ideal data interchange language. JSON syntax is a subset of the JavaScript syntax, and consists of two primary structures: objects and arrays. 

        - **Objects**: An object in JSON is a collection of key/value pairs enclosed in curly braces {}. Each key is followed by a colon (:) and then the value, with key/value pairs separated by commas.
        - **Arrays**: An array in JSON is an ordered list of values, which are enclosed in square brackets []. Values within the array are separated by commas.

        The value in a key/value pair can be a string, number, boolean, other objects, array, or null. Strings must be written in double quotes, and keys must be strings. This simple yet powerful syntax forms the backbone of JSON's data interchange capability, allowing for structured data storage similar to XML but with less overhead.`,
        example: `{
    "employees": [
        { "firstName": "John", "lastName": "Doe" },
        { "firstName": "Anna", "lastName": "Smith" }
    ]
}`
    },
    {
        id: 3,
        title: "JSON vs XML",
        content: `Unlike XML, JSON formats are text-based, lighter, and quicker for both writing and reading data. JSON does not use end tag, is shorter, quicker to read and write, and can use arrays directly.`,
        example: `JSON: {"name": "John", "age": 30}
XML: <person><name>John</name><age>30</age></person>`
    },
    {
        id: 4,
        title: "Data Types",
        content: `JSON supports various data types including strings, numbers, booleans, arrays, objects, and null. These allow JSON to easily represent simple data structures and associative arrays (hashes).`,
        example: `{
    "name": "Alice",
    "age": 25,
    "isStudent": false,
    "courses": ["Mathematics", "English"],
    "address": null
}`
    },
    {
        id: 5,
        title: "Parsing JSON",
        content: `Parsing JSON involves converting the data from a string format back into a native data format. In JavaScript, this can be achieved using the JSON.parse() method which transforms a string of JSON text into a JavaScript object.`,
        example: `const jsonData = '{"name": "John", "age": 30}';
const obj = JSON.parse(jsonData);
console.log(obj.name); // Output: John`
    },
    {
        id: 6,
        title: "Stringifying JSON",
        content: `Stringifying involves converting a native JavaScript object into a string of JSON text. This is done using the JSON.stringify() method, which takes an object and returns a JSON string.`,
        example: `const obj = {name: "John", age: 30};
const jsonString = JSON.stringify(obj);
console.log(jsonString); // Output: '{"name":"John","age":30}'`
    },
    {
        id: 7,
        title: "Using JSON in Web Servers",
        content: `JSON is commonly used to send data from the server to the client in web applications. It is easy to integrate into existing server code, and it works seamlessly with most modern web APIs.`,
        example: `fetch('https://api.example.com/data')
.then(response => response.json())
.then(data => console.log(data));`
    },
    {
        id: 8,
        title: "JSON with PHP, HTML, and JavaScript",
        content: `JSON can be used together with PHP to create dynamic server-side scripts, with HTML to store information invisibly in the DOM, and with JavaScript to manipulate the data and render it in the browser.`,
        example: `// PHP echoes JSON to client
echo json_encode($data);

// JavaScript fetches and processes JSON
fetch('data.php')
.then(response => response.json())
.then(data => {
    document.getElementById('output').innerHTML = data.name;
});`
    },
];

const JSONEducation = () => {
    const [activeTopic, setActiveTopic] = useState(topics[0]);

    return (
        <div>
            <h1>JSON Education</h1>
            {topics.map(topic => (
                <div key={topic.id}>
                    <button onClick={() => setActiveTopic(topic === activeTopic ? {} : topic)} style={{ width: '100%', textAlign: 'left', padding: '10px', fontSize: '16px', background: topic === activeTopic ? '#ccc' : '#f9f9f9', border: 'none', borderBottom: '1px solid #ddd' }}>
                        {topic.title}
                    </button>
                    {activeTopic.id === topic.id && (
                        <div style={{ padding: '20px', background: '#f0f0f0', borderLeft: '1px solid #ccc', borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc' }}>
                            <p>{activeTopic.content}</p>
                            <pre style={{ background: '#eef', padding: '15px', borderRadius: '5px' }}>{activeTopic.example}</pre>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default JSONEducation;